import { ROOT_ADMIN, ROOT_EMPLOYEE } from "../constants/HelperConstants";
import {
  PAY_PUP_ADMIN_EMAIL,
  PAY_PUP_LS_AUTH_TOKEN,
  PAY_PUP_LS_AUTH_USER_DETAILS,
  PAY_PUP_LS_AUTH_USER_ID,
  PAY_PUP_LS_AUTH_USER_ROLE,
  PAY_PUP_LS_AGENCY_ID,
  PAY_PUP_AGENCY_URL,
  PAY_PUP_IS_ROOTUSER,
} from "../constants/LocalStorageVariables";
import API from "../redux/actions/API";
import CustomButtonLoader from "./CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {  useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import {
  ADMIN_DASHBOARD_ROUTE,
  AGENCY_DASHBOARD_ROUTE,
} from "../constants/RoutePaths";
import loginBg from "../images/loginbg.svg";
import logo from "../images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { AUTH_USER_DETAILS_SUCCESS } from "../redux/actions/ActionTypes";
import { LOGIN_URL, ALL_AGENCY_LIST } from "../constants/ApiPaths";
import ResetPassword from "./ResetPassword";
import { locationParams } from "../functions/Helper";
import BackButtonSvg from "./common/BackButtonSvg";

export default function SigninAuthPage() {
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const role=''
  const [PassFlag, setPassFlag] = useState(true);
  const [UserData, setUserData] = useState([]);
  const dispatch = useDispatch();
  const [token, settoken] = useState("");

  // toogle paswword icon

  const filter = locationParams(location.search);
  const rootPath = window.location.origin;
  //Sign In
  const LogIn = async (values) => {
    setLoading(true);

    const config = {
      method: "POST",
      url: LOGIN_URL,
      data: { ...values, userRole: role },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      const { accesstoken } = response.headers;
      const {
        firstName,
        email,
        lastName,
        agencyId,
        isDefaultPassword,
        userId,
        roleName,
        agencyUrl,
        isRootUser,
      } = data;
      if (status === "Success") {
        localStorage.setItem(PAY_PUP_ADMIN_EMAIL, email);
        localStorage.setItem(PAY_PUP_LS_AUTH_USER_ROLE, roleName);
        localStorage.setItem(
          PAY_PUP_LS_AUTH_USER_DETAILS,
          JSON.stringify(data)
        );
        settoken(accesstoken);
        setUserData(data);
        if (isDefaultPassword) {
          setPassFlag(false);
        } else {
          dispatch({
            type: AUTH_USER_DETAILS_SUCCESS,
            payload: data,
          });
          CustomAlertMessage(
            "Logged in. Welcome " + firstName + ` ` + lastName,
            "success",
            enqueueSnackbar
          );
          localStorage.setItem(PAY_PUP_LS_AUTH_TOKEN, accesstoken);
          localStorage.setItem(PAY_PUP_LS_AUTH_USER_ID, userId);
          localStorage.setItem(PAY_PUP_LS_AGENCY_ID, agencyId);
          localStorage.setItem(PAY_PUP_IS_ROOTUSER, isRootUser);
          localStorage.setItem(PAY_PUP_AGENCY_URL, agencyUrl);
          const Root = [ROOT_ADMIN, ROOT_EMPLOYEE].includes(roleName);

          if (filter.ref) {
            history(filter.ref.replace(rootPath, ""));
          } else if (Root) {
            history(ADMIN_DASHBOARD_ROUTE);
          } else {
            history(AGENCY_DASHBOARD_ROUTE);
          }
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email("Invalid email")
      .required("Email Required"),
    password: Yup.string().required("Password Required"),
  });

  const { handleSubmit, handleChange, values, handleBlur, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema,
      onSubmit: (values) => LogIn(values),
    });
  const getAllAgency = async () => {
    const config = {
      method: "POST",
      url: ALL_AGENCY_LIST,
      // headers: authHeader(),
      data: {
        count: 10,
        offset: 0,
        agencyName: "",
        email: "suganthans+1@apptomate.co",
      },
    };
    const response = await API(config);
    console.log(response)
  };
  useEffect(() => {
    getAllAgency();
  }, []);
  return (
    <div>
      <Container fluid>
        <Row>
          <Col md="5" lg="6" className="loginBg-end">
            <img alt="Logo" src={loginBg} className="w-100" />
          </Col>
          {PassFlag ? (
            <Col md="7" lg="6" className="d-flex">
              <div className="login-form">
                <img alt="Logo" className="logo" src={logo} />
                <div className="top-btn">
                  <Button
                    color="primary"
                    style={{
                      backgroundColor: "#9ba0a4",
                      borderColor: "#9ba0a4",
                    }}
                  >
                    <BackButtonSvg />
                    Back
                  </Button>
                </div>
                <br />
                <Button color="primary" block>
                  {loading && <CustomButtonLoader />} Login to the admin portal
                </Button>
                <br />
                <p>Or</p>
                <Form form="true" onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label for="exampleEmail">Organization</Label>
                    <Input
                      type="select"
                      onBlur={handleBlur}
                      name="email"
                      values={values.email}
                      invalid={touched.email && errors.email ? true : false}
                      onChange={handleChange}
                      id="exampleEmail"
                      placeholder="Select your organization"
                    />
                    <FormFeedback>
                      {touched.email && errors.email ? errors.email : ""}
                    </FormFeedback>
                  </FormGroup>

                  <Button color="primary" block>
                    {loading && <CustomButtonLoader />} SIGN IN
                  </Button>
                </Form>
              </div>
            </Col>
          ) : (
            <Col md="6" className="d-flex">
              <ResetPassword token={token} UserData={UserData} />
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
